import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"
// import { AttractionType } from "@/common/types"

function useListAdvertisements({
  filters,
}: {
  filters: { filterValue?: string }
}) {
  return useQuery({
    queryKey: queryKeys.advertisements.list({}).queryKey,
    queryFn: () =>
      client
        .get(`/advertisements/`, { params: { ...filters } })
        .then((response) => response.data),
  })
}
export default useListAdvertisements
